<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="grandma-on-the-run">
<h1>Grandma on the Run</h1>
<div class="section level2" id="the-set-up">
<h2>The Set Up</h2>
<p>Opened up today’s mail. Got a new assignment: Serve an old lady divorce papers. My client’s cover letter told me she was a 74-year-old woman living in an assisted living home. Apparently, her husband of 45 years finally wanted out; seemed like an easy one.</p>
</div>
<div class="section level2" id="the-play">
<h2>The Play</h2>
<p style="text-indent:1em;">I drove to the small town—it was up north, built into the hillsides. Seemed like a nice, fall day and a nice small town, until I got to my destination.</p>
<p>I arrived at the assisted living home and found it to be a secured apartment complex. With my badge hanging around my neck and papers in hand, I went inside to the lobby of the building. I looked at the directory and buzzer and saw that the only one labeled was the office button. I buzzed the office button and spoke with the manager. I told him who I was and what I was doing, and who I was looking for. He was cooperative and said he would send my old lady friend out to the front door.</p>
<p>As the frail old woman in a bathrobe came to the glass door, I told her I was a private detective. She looked at my badge as I told her, “Margaret—I have some papers here for you. Could you open the door for me?”</p>
<p>“No!” she yelled. “I don’t want them! You can keep.”</p>
<p>“Margaret, these are court documents and you have to take them,” I told her, as she turned around and started to walk away. I’ve never seen an old woman move so fast.</p>
<p>I went back outside and happened to see a local police car driving through the parking lot. I flagged him down to talk, and explained to him my dilemma. He was friendly enough, so I asked him if he could help me get inside.</p>
<p>“I got an idea,” he told me. “There’s a retired police captain that lives in there. I’ll give him a call and he can let you in.” I went back inside the lobby, and after a few minutes, a really tall gray-haired gentleman came up to the door.</p>
<p>“Hi, I’m Frank. I’m a retired police captain from here in town, can I help you?” he asked.</p>
<p>“Do you know Margaret M.P?”</p>
<p>“Oh yes, I know Margaret,” he said, looking at my badge.</p>
<p>“I’ll let you in and take you to her apartment.”</p>
<p>As we walked down the hallways, he eventually stopped in the middle of a long hallway and pointed to a door at the end of the hall. “That’s her apartment. I’m going now as I don’t want any trouble with any of the other residents.”</p>
<p>I proceeded down and knocked on the door. It was quiet inside, so I called her name several times while knocking, “Margaret, this is the detective at the door—we have to talk.”</p>
<p>Finally, I heard her inside—she must have been near the door and was apparently talking on the phone. I could hear her—it seemed she called a reverend.</p>
<p>“Reverend James, I need help!” she quipped. “My husband and I are not getting along. He doesn’t love me anymore and there’s a detective after me!”</p>
<p>“Margaret, I’m still here and I won’t go away!” I slid the papers under the door, but they wouldn’t go in all the way.</p>
<p>I think I was hitting her feet on the other side of the door. “I know you’ve got them now and you are officially served.”</p>
<p>I walked quickly back to the lobby before the old bat had a chance to run after me. After getting dirty looks from some of the other residents, I finally made it back outside. Wow, fresh air again. Now I know why the old man was divorcing this crazy lady after 45 years. I started my long journey home, happy to complete this assignment. It wasn’t as easy as I thought, but at least I got to meet one of the fastest ass-kicking old ladies on the planet.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?13c68a7a